// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"favorites_mainWrapper__fKZPf"};